import defineReadAutoAction from '~/prix/actions/defineReadAutoAction'
import legalEntityAttendanceDataSourceReadAction from './legalEntityAttendanceDataSourceRead.action.json' assert { type: 'json' }

const legalEntityAttendanceDataSourceReadDefinition = defineReadAutoAction(
  legalEntityAttendanceDataSourceReadAction,
  'legalEntityAttendanceDataSource',
)

export default legalEntityAttendanceDataSourceReadDefinition
